/**
 * Versions of the public legal text that requires an affirmative product action.
 *
 * Dates match the public page `updated` values. Bump the Terms version when a
 * material Terms change requires renewed assent. Privacy changes can be noticed
 * without renewed acknowledgement unless the product deliberately bumps the
 * required version here.
 */
export const LEGAL_VERSIONS = {
  terms: "2026-08-13",
  // 2026-08-26: added Intuit Mailchimp to the subprocessor disclosure for the
  // opt-in marketing list (homepage capture + contact-prefs marketing email).
  privacy: "2026-08-26",
  projectAuthorization: "2026-08-13",
} as const;

export const PROJECT_AUTHORIZATION_CONFIRMATION =
  "By selecting Run analysis, you confirm that you’re authorized to share this project’s CI/CD data with DeployCompare.";
